import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { ImageLogo } from '~/assets/images';
import { Button } from '~/components';
import { UserDataStateLocation } from '~/models';

import { SignUpCompleteFormData } from '../modules/Professional/SignUpComplete';

import { Container, Wrapper, Title, Description, Price } from './styles';

const SignPlan = () => {
  const { t } = useTranslation(['Professional:SignUp']);
  const { push } = useHistory();
  const {
    state: { userData, completeSignUpData },
  } = useLocation<{
    userData: UserDataStateLocation;
    completeSignUpData: SignUpCompleteFormData;
  }>();

  const navigateToSignComplete = useCallback(() => {
    push('/professional/sign-up/complete/payment-card', {
      userData,
      completeSignUpData,
    });
  }, [push, userData, completeSignUpData]);

  return (
    <Container>
      <Wrapper>
        <Title>Assinatura de plano</Title>

        <ImageLogo />

        <Description>
          <li>
            Sistema de cadastro e CRM de até <b>250 alunos</b>
          </li>

          <li>
            Sistema de <b>gestão comercial e financeira</b>
          </li>

          <li>
            Prescrição técnica de treinamento <b>100% automatizado</b>
          </li>

          <li>
            Sistema de performance e treinamento do aluno com biblioteca
            integrada de videoaulas.
          </li>

          <li>
            Gerenciador de Perfil, Gestão e Periodização de Programas de
            Treinamento
          </li>
        </Description>

        <Price>
          <h1>R$39,90</h1>
        </Price>

        <Button onClick={navigateToSignComplete} style={{ maxWidth: 387 }}>
          {t('Professional:SignUp.continue')}
        </Button>
      </Wrapper>
    </Container>
  );
};

export default SignPlan;
